module.exports = __webpack_public_path__ + "static/media/contacts.e10df771.svg";